import api from './api';

const roleService = {
  list: () => api.get('/roles'),
  get: (id) => api.get(`/roles/${id}`),
  create: (payload) => {
    // Ensure permissions is an object, not a string
    const data = {
      name: payload.name,
      permissions: typeof payload.permissions === 'string' ? JSON.parse(payload.permissions) : payload.permissions
    };
    console.log('[ROLE SERVICE CREATE] Sending data:', JSON.stringify(data, null, 2));
    return api.post('/roles', data).then(res => {
      console.log('[ROLE SERVICE CREATE] Response:', res.data);
      return res;
    }).catch(err => {
      console.error('[ROLE SERVICE CREATE] Error:', err.response?.data || err.message);
      throw err;
    });
  },
  update: (id, payload) => {
    // Ensure permissions is an object, not a string
    const data = {
      name: payload.name,
      permissions: typeof payload.permissions === 'string' ? JSON.parse(payload.permissions) : payload.permissions
    };
    console.log('[ROLE SERVICE UPDATE] Sending data:', JSON.stringify(data, null, 2));
    return api.put(`/roles/${id}`, data).then(res => {
      console.log('[ROLE SERVICE UPDATE] Response:', res.data);
      return res;
    }).catch(err => {
      console.error('[ROLE SERVICE UPDATE] Error:', err.response?.data || err.message);
      throw err;
    });
  },
  remove: (id) => api.delete(`/roles/${id}`)
};

export default roleService;
